import { Component, Input } from '@angular/core';
import { BehaviorSubject, filter, map } from 'rxjs';
import { Job } from 'server/shared/models/job';
import {
  isNonDefaultCustomCriterion,
  NonDefaultCustomCriteriaRow,
  toNonDefaultCustomCriteriaRow,
} from 'src/helpers/customCriteriaRowHelpers';
import { filterIsNotEmpty } from '../../../helpers/filterIsNotEmpty';

@Component({
  selector: 'app-pooler-job-list-item-details-table',
  templateUrl: './pooler-job-list-item-details-table.component.html',
  styleUrls: ['./pooler-job-list-item-details-table.component.scss'],
})
export class PoolerJobListItemDetailsTableComponent {
  job$ = new BehaviorSubject<Job | undefined>(undefined);
  @Input() set job(job: Job | undefined) {
    this.job$.next(job);
  }
  get job(): Job | undefined {
    return this.job$.getValue();
  }
  jobCertificates$ = this.job$.pipe(
    filter(filterIsNotEmpty),
    map((job) => {
      if (!job.certificates?.length) {
        return;
      }
      return job.certificates.map((c) => c.displayName).join(', ');
    }),
  );

  nonDefaultCustomCriteriaRows$ = this.job$.pipe(
    filter(filterIsNotEmpty),
    map((job) => {
      const customerId = job.yourself?.customer?.id ?? job.customer.id;
      const criteriaMap =
        job.customerInternalInformation?.[customerId]?.customCriteria;
      if (!criteriaMap) {
        return [] as NonDefaultCustomCriteriaRow[];
      }
      return Object.values(criteriaMap)
        .filter(isNonDefaultCustomCriterion)
        .map(toNonDefaultCustomCriteriaRow);
    }),
  );

  constructor() {}

  trackByCustomCriteriaLabel(
    _index: number,
    row: NonDefaultCustomCriteriaRow,
  ): string {
    return row.label;
  }
}
